import { Route } from 'src/routes/Route'

export const TestLaunchRoute = Route({ path: '/test-launch', hideTopBar: true })
export type TestLaunchRoute = Route<typeof TestLaunchRoute>
